import { FormControl, FormGroup } from '@angular/forms';

export class FormGroupBackup {
    private formGroupBackup = new FormGroup({});

    constructor(private readonly formGroupOriginal: FormGroup) {}

    create() {
        this.formGroupBackup = this.deepCopy(this.formGroupOriginal);
    }

    restore() {
        this.restoreDeepCopy(this.formGroupBackup, this.formGroupOriginal);
    }

    /**
     * Create recursively a form group deep copy inclusive nested form groups.
     * private
     * @param original - the form group to create a deep copy from
     */
    private deepCopy(original: FormGroup) {
        const backup = new FormGroup({});
        Object.keys(original.controls).forEach((controlName) => {
            const controlOriginal = original.controls[controlName];
            if (controlOriginal instanceof FormControl) {
                backup.setControl(controlName, new FormControl(controlOriginal.value));
            } else if (controlOriginal instanceof FormGroup) {
                backup.setControl(controlName, this.deepCopy(controlOriginal));
            }
        });
        return backup;
    }

    /**
     * Restore recursively a form group deep copy inclusive nested form groups.
     * private
     * @param deepCopy - the deep copy to restore to the original form group
     * @param original - the form group to restore the deep copy to
     */
    private restoreDeepCopy(deepCopy: FormGroup, original: FormGroup) {
        Object.keys(deepCopy.controls).forEach((controlName) => {
            const controlCopy = deepCopy.controls[controlName];
            if (controlCopy instanceof FormControl) {
                original.get(controlName).patchValue(controlCopy.value);
            } else if (controlCopy instanceof FormGroup) {
                this.restoreDeepCopy(controlCopy, original.get(controlName) as FormGroup);
            }
        });
    }
}
